module.exports = __webpack_public_path__ + "static/media/icon_settings_bot_apagado.e66d287d.svg";